let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("avhPy")).then(() => parcelRequire('kjrhr'));